<template>
  <nav class="navbar navbar-expand-lg bg-white shadow-sm">
    <div class="container-fluid m-0">
      <router-link  class="navbar-item logo" style="font-family: UnisansBoldItalic; font-size: 2rem; text-decoration: none; border-bottom: unset; outline: none" to="/">
<!--        <img src="../../assets/crewhr.png" width="80">-->
                <span style="font-family: UnisansBoldItalic;color: #d51317">
                    core
                </span>
          <span style="font-family: UnisansBoldItalic; color: rgb(0, 0, 0.7)">
                     crewbox
                </span>
      </router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
<!--          <li class="nav-item">
            <a class="nav-link" href="/">HR Personel</a>
          </li>-->

        </ul>
        <span class="d-flex nav-item" @click="logout" style="cursor: pointer">
        <div style="font-size: 16px"><a class="nav-link" href="">Logout</a></div>
          <div style="margin: 2px 0 0 5px"><i class="icon-exit"/></div>
      </span>
      </div>

    </div>
  </nav>
</template>
<style>
.navbar {
  font-size: 14px;
}
</style>
<script>
import {mapActions} from "vuex";

export default {
  methods: {
    ...mapActions("auth", ["logout"]),
  }
}
</script>
